// Latinco: abre y cierra el menú rojo a pantalla completa
(() => {
  const menu = document.getElementById('LtnMenu');
  if (!menu) return;
  const burger = document.querySelector('.ltn-burger');
  const search = menu.querySelector('#LtnSearch');
  let lastFocus = null;

  const open = (focusSearch) => {
    lastFocus = document.activeElement;
    menu.classList.add('is-open');
    menu.setAttribute('aria-hidden', 'false');
    burger?.setAttribute('aria-expanded', 'true');
    document.body.classList.add('ltn-menu-open');
    setTimeout(() => (focusSearch ? search : menu.querySelector('.ltn-menu__close'))?.focus({ preventScroll: true }), 450);
  };

  const close = () => {
    menu.classList.remove('is-open');
    menu.setAttribute('aria-hidden', 'true');
    burger?.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('ltn-menu-open');
    lastFocus?.focus?.({ preventScroll: true });
  };

  document.querySelectorAll('[data-ltn-menu-open]').forEach((el) =>
    el.addEventListener('click', (event) => {
      event.preventDefault();
      open(el.hasAttribute('data-ltn-focus-search'));
    })
  );
  menu.querySelectorAll('[data-ltn-menu-close]').forEach((el) => el.addEventListener('click', close));
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && menu.classList.contains('is-open')) close();
  });
})();
